<template>
  <v-list>
      <v-list-subheader>{{ item.title }}</v-list-subheader>
      <v-list-item>
          <v-text-field clearable :label="$tr('Время жизни ревизий, дн')" v-model="revisionTime"
              :rules="[rules.number]">
          </v-text-field>
      </v-list-item>
      <v-list-item>
          <v-text-field clearable :label="$tr('Количество ревизий')" v-model="revisionSize"
              :rules="[rules.number]">
          </v-text-field>
      </v-list-item>
      <v-list-item>
          <v-text-field clearable :label="$tr('Время жизни корзины, дн')" v-model="trashTime"
              :rules="[rules.number]">
          </v-text-field>
      </v-list-item>
  </v-list>
</template>

<script>
export default {
    name: 'SettingsItemView',
    props: {
        item: Object,
        api: Object,
    },
    data() {
        return {
            revisionTime: this.item.revision_time / (3600 * 24),
            revisionSize: this.item.revision_size,
            trashTime: this.item.trash_time / (3600 * 24),
            rules: {
                number: (value) => parseInt(value, 10) > 0 || this.$tr('Положительное число'),
            },
        };
    },
    watch: {
        revisionTime(value) {
            const n = parseInt(value, 10);
            if (n > 0) {
                this.api.setSettings('revision_time', n * 3600 * 24, this.item.id);
            }
        },
        revisionSize(value) {
            const n = parseInt(value, 10);
            if (n > 0) {
                this.api.setSettings('revision_size', n, this.item.id);
            }
        },
        trashTime(value) {
            const n = parseInt(value, 10);
            if (n > 0) {
                this.api.setSettings('trash_time', n * 3600 * 24, this.item.id);
            }
        },
    },
};
</script>

<style>

</style>
